import { axiosClient } from "api/axiosClient";
import { 
  ProcessCardRequest, 
  ProcessCardResponse,
  ImprovePullRequestRequest,
  ImprovePullRequestResponse,
  GetProcessStatusParams, 
  GetProcessStatusResponse,
  GetCardJobsResponse,
  CancelProcessResponse,
  RetryProcessResponse,
  CodeBotJob
} from "@freetech/models/codebot";

export const codebotFunctions = {
  processCard: async (request: ProcessCardRequest): Promise<ProcessCardResponse> => {
    return await axiosClient.post("/codebot/process-card", request);
  },

  improvePullRequest: async (request: ImprovePullRequestRequest): Promise<ImprovePullRequestResponse> => {
    return await axiosClient.post("/codebot/improve-pull-request", request);
  },

  getProcessStatus: async (params: GetProcessStatusParams): Promise<GetProcessStatusResponse> => {
    return await axiosClient.get(`/codebot/process-status/${params.processId}`);
  },

  getCardJobs: async (cardId: string): Promise<GetCardJobsResponse> => {
    return await axiosClient.get(`/codebot/card-jobs/${cardId}`);
  },

  cancelProcess: async (processId: string): Promise<CancelProcessResponse> => {
    return await axiosClient.delete(`/codebot/cancel-process/${processId}`);
  },

  retryProcess: async (processId: string): Promise<RetryProcessResponse> => {
    return await axiosClient.post(`/codebot/retry-process/${processId}`);
  },
}; 